import React from 'react'
import PropTypes from 'prop-types'
import { states } from 'theme/default'

export const inputStates = states

export const hasValue = (value) => value !== '' && value !== null && value !== undefined

class InputState extends React.PureComponent {
  static propTypes = {
    type: PropTypes.oneOf(['text', 'password', 'email', 'number', 'phone']),
    state: PropTypes.oneOf(Object.keys(inputStates)),
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    inputRef: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    controlled: PropTypes.bool,
    disabled: PropTypes.bool,
    withError: PropTypes.bool,
    disableAutocomplete: PropTypes.bool,
    inputMode: PropTypes.string,
    pattern: PropTypes.string,
    maxLength: PropTypes.number,
    autoFocus: PropTypes.bool,
    textTransform: PropTypes.string
  }

  static defaultProps = {
    type: 'text',
    value: '',
    inputRef: () => {},
    onFocus: () => {},
    onBlur: () => {},
    onChange: () => {},
    onKeyDown: () => {},
    controlled: false
  }

  static getDerivedStateFromProps (nextProps) {
    if (nextProps.controlled) {
      return {
        value: nextProps.value
      }
    }
    return null
  }

  constructor (props) {
    super(props)
    this.state = {
      focus: false,
      value: props.value || ''
    }
  }

  onFocus = () => this.setState({ focus: true }, this.props.onFocus)

  onBlur = () => this.setState({ focus: false }, this.props.onBlur.bind(null, this.props.name, this.state.value))

  onChange = (e) => {
    const { name, onChange, controlled } = this.props
    const { value } = e.target
    if (controlled) {
      onChange(name, value)
    } else {
      this.setState({ value }, onChange.bind(null, name, value))
    }
  }

  getInputState = () => {
    const { withError, state } = this.props
    if (withError) return inputStates.error
    return state
  }

  getInputProps = () => {
    const { name, className, inputRef, type, disableAutocomplete, placeholder, disabled, withError, onKeyDown, inputMode, pattern, maxLength, autoFocus, textTransform, ...props } = this.props
    const { value } = this.state
    return {
      id: name,
      className,
      ref: inputRef,
      type,
      autoComplete: disableAutocomplete ? 'off' : undefined,
      placeholder,
      name,
      value,
      disabled,
      withError,
      onChange: this.onChange,
      onKeyDown,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      inputMode,
      pattern,
      maxLength,
      autoFocus,
      textTransform,
      'data-testid': props['data-testid']
    }
  }

  getLabelProps = () => {
    const { name } = this.props
    const { focus, value } = this.state
    return {
      htmlFor: name,
      focus: focus || hasValue(value)
    }
  }

  render () {
    const { children } = this.props
    const { focus, value } = this.state
    const state = this.getInputState()

    return children({
      getInputProps: this.getInputProps,
      getLabelProps: this.getLabelProps,
      focus,
      value,
      state
    })
  }
}

export default InputState
